export { StatusLegendModule } from './status-legend.module';

export {
   StatusLegendComponent,
   SharedKeys,
   SharedKeysMap,
   SharedKeysEnum,
} from './status-legend.component';
